import { TitleCasePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatMenuModule } from '@angular/material/menu';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { connectState } from '@examdojo/angular/util';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslocoPipe } from '@jsverse/transloco';
import { MtxPopoverModule } from '@ng-matero/extensions/popover';
import { UntilDestroy } from '@ngneat/until-destroy';
import { AssetTreeSettingsService } from '../asset-tree-settings.service';
import { AssetTreeUiService } from '../asset-tree/asset-tree-ui.service';
import { AssetTreeToolbarSettingsComponent } from './asset-tree-toolbar-settings/asset-tree-toolbar-settings.component';
import { AssetTreeBadgeType } from './asset-tree-toolbar.model';

@UntilDestroy()
@Component({
  selector: 'exam-asset-tree-toolbar',
  templateUrl: './asset-tree-toolbar.component.html',
  styleUrls: ['./asset-tree-toolbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatButtonModule,
    FontAwesomeModule,
    MatMenuModule,
    MatExpansionModule,
    MatRadioModule,
    ReactiveFormsModule,
    MtxPopoverModule,
    MatTooltipModule,
    AssetTreeToolbarSettingsComponent,
    TranslocoPipe,
    TitleCasePipe,
  ],
})
export class AssetTreeToolbarComponent {
  constructor(
    private readonly assetTreeToolbarService: AssetTreeSettingsService,
    private readonly assetTreeUiService: AssetTreeUiService,
  ) {}

  readonly state = connectState({
    scrolled: this.assetTreeUiService.scrolled$,
  });

  setBadgeType(event: AssetTreeBadgeType) {
    this.assetTreeToolbarService.setBadgeType(event);
  }
}
